$(document).ready(function () {
  // Enhanced Lazy Loading with Intersection Observer (jQuery version)
  function initEnhancedLazyLoading() {
    // Check if Intersection Observer is supported
    if (!("IntersectionObserver" in window)) {
      // Fallback for older browsers - just load all images immediately
      $(
        'img[loading="lazy"], iframe[loading="lazy"], video[loading="lazy"]'
      ).addClass("loaded");
      return;
    }

    // Create intersection observer with optimized settings
    const imageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const $element = $(entry.target);

            // Handle different element types
            if (entry.target.tagName === "IMG") {
              // For images, we can use the native loading="lazy" attribute
              // But we'll add a class for smooth transition
              $element.on("load", function () {
                $(this).addClass("loaded");
              });

              // If image is already cached, trigger load event immediately
              if (entry.target.complete) {
                $element.addClass("loaded");
              }
            } else if (entry.target.tagName === "IFRAME") {
              // For iframes, we'll add the loaded class after a short delay
              // to ensure smooth transition
              setTimeout(() => {
                $element.addClass("loaded");
              }, 100);
            } else if (entry.target.tagName === "VIDEO") {
              // For videos, add loaded class when metadata is loaded
              $element.on("loadedmetadata", function () {
                $(this).addClass("loaded");
              });

              // If video metadata is already loaded
              if (entry.target.readyState >= 1) {
                $element.addClass("loaded");
              }
            }

            // Stop observing this element
            observer.unobserve(entry.target);
          }
        });
      },
      {
        // Load images when they're 50px away from entering the viewport
        rootMargin: "50px 0px",
        threshold: 0.01,
      }
    );

    // Observe all lazy-loaded elements
    $(
      'img[loading="lazy"], iframe[loading="lazy"], video[loading="lazy"]'
    ).each(function () {
      imageObserver.observe(this);
    });

    // Preload critical images (above the fold)
    $('img[loading="lazy"]:not(.loaded)').each(function () {
      const $img = $(this);
      const rect = this.getBoundingClientRect();
      // If image is above the fold or close to it, load immediately
      if (rect.top < $(window).height() + 100) {
        $img.addClass("loaded");
      }
    });
  }

  // Initialize enhanced lazy loading
  initEnhancedLazyLoading();

  // Initialize video autoplay on scroll
  function initVideoAutoplay() {
    const $videos = $('video[loading="lazy"]');

    if ($videos.length === 0) return;

    // Create intersection observer for videos
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            // Video is in viewport, try to play
            video.play().catch((e) => {
              console.log("Video autoplay failed:", e);
            });
          } else {
            // Video is out of viewport, pause to save resources
            video.pause();
          }
        });
      },
      {
        threshold: 0.5, // Play when 50% of video is visible
        rootMargin: "0px",
      }
    );

    // Observe all lazy videos
    $videos.each(function () {
      videoObserver.observe(this);
    });
  }

  // Initialize video autoplay
  initVideoAutoplay();

  // Performance optimization: Preload images on hover
  function initImagePreloading() {
    $('img[loading="lazy"]').on("mouseenter", function () {
      const $img = $(this);
      // Preload image on hover for better UX
      if (!$img.hasClass("loaded")) {
        const tempImg = new Image();
        tempImg.src = this.src;
      }
    });
  }

  // Initialize image preloading
  initImagePreloading();

  // Error handling for failed image loads
  function initImageErrorHandling() {
    $('img[loading="lazy"]').on("error", function () {
      const $img = $(this);
      // Add error class for styling
      $img.addClass("load-error loaded"); // Still show the element

      // Optional: Set a placeholder image
      // $img.attr('src', 'images/placeholder.jpg');
    });
  }

  // Initialize error handling
  initImageErrorHandling();

  // Preload Product Features images for smooth tab switching
  function preloadProductFeaturesImages() {
    $(".xp-product-features__image").each(function () {
      const $img = $(this);
      if (!$img.hasClass("loaded")) {
        const tempImg = new Image();
        tempImg.onload = function () {
          $img.addClass("loaded");
        };
        tempImg.src = this.src;
      }
    });
  }

  // Initialize preloading for product features images
  preloadProductFeaturesImages();

  // Reusable function to initialize any slider
  function initSlider(selector, options = {}) {
    if ($(selector).length) {
      const defaultConfig = {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        grabCursor: true,
        // Events
        on: {
          init: function () {
            $(this.wrapperEl).css(
              "transition-timing-function",
              "cubic-bezier(0.25, 0.46, 0.45, 0.94)"
            );
          },
          slideChangeTransitionStart: function () {
            $(this.wrapperEl).css(
              "transition-timing-function",
              "cubic-bezier(0.25, 0.46, 0.45, 0.94)"
            );
          },
        },
      };

      // Merge default config with custom options
      const config = { ...defaultConfig, ...options };

      return new Swiper(selector, config);
    }
    return null;
  }

  // Initialize all sliders
  const sliders = [
    {
      selector: ".xp-products-swiper",
      options: {
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        // containerModifierClass: true,
        navigation: {
          nextEl: ".xp-products-button-next",
          prevEl: ".xp-products-button-prev",
        },
        a11y: {
          prevSlideMessage: "Previous product",
          nextSlideMessage: "Next product",
          firstSlideMessage: "This is the first product",
          lastSlideMessage: "This is the last product",
        },
      },
    },
    {
      selector: ".xp-highlighted-products__slider .xp-swiper",
      options: {
        navigation: {
          nextEl: ".xp-highlighted-products__slider .xp-swiper-button-next",
          prevEl: ".xp-highlighted-products__slider .xp-swiper-button-prev",
        },
        a11y: {
          prevSlideMessage: "Previous highlighted product",
          nextSlideMessage: "Next highlighted product",
          firstSlideMessage: "This is the first highlighted product",
          lastSlideMessage: "This is the last highlighted product",
        },
      },
    },
  ];

  // Initialize all sliders
  sliders.forEach((slider) => {
    initSlider(slider.selector, slider.options);
  });

  // Simple tab switching functionality (just visual for now)
  $(".xp-products__tab").on("click", function () {
    const $this = $(this);

    // Remove active class from all tabs
    $(".xp-products__tab").removeClass("xp-products__tab--active");

    // Add active class to clicked tab
    $this.addClass("xp-products__tab--active");
  });

  // FAQ Accordion functionality
  function initFAQ() {
    // Initialize the first FAQ item if it has active class
    const $activeItem = $(".xp-faq__item--active");
    if ($activeItem.length) {
      const $answer = $activeItem.find(".xp-faq__answer");
      const answerHeight = $answer[0].scrollHeight;
      $answer.css("max-height", answerHeight + 10 + "px");
    }
  }

  // Initialize FAQ on page load
  initFAQ();

  //  Scroll Animation
  function initScrollAnimations() {
    const observerOptions = {
      threshold: 0.15,
      rootMargin: "0px 0px -100px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const $element = $(entry.target);
        if (entry.isIntersecting && !$element.hasClass("scroll-animated")) {
          const animationType = $element.data("animationType");
          const delay = parseInt($element.data("animationDelay")) || 0;

          // Use requestAnimationFrame for smoother performance
          requestAnimationFrame(() => {
            setTimeout(() => {
              // Mark as animated to prevent conflicts
              $element.addClass("scroll-animated");

              // Function to apply animation to an element
              function applyAnimation($targetElement, animType) {
                // Reset and trigger animation
                $targetElement.css({
                  animation: "none",
                  opacity: "0",
                });

                // Set initial transform based on animation type
                if (animType === "fadeInUp") {
                  $targetElement.css("transform", "translateY(30px)");
                } else if (animType === "fadeInLeft") {
                  $targetElement.css("transform", "translateX(50px)");
                } else if (animType === "fadeIn") {
                  $targetElement.css("transform", "scale(0.9)");
                }

                // Force reflow
                $targetElement[0].offsetHeight;

                // Trigger animation with optimized transition
                $targetElement.css({
                  transition:
                    "opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  opacity: "1",
                  transform:
                    animType === "fadeIn"
                      ? "scale(1)"
                      : "translateY(0) translateX(0)",
                });

                // Clean up after animation
                setTimeout(() => {
                  $targetElement.css({
                    transition: "",
                    transform: "",
                  });
                }, 800);
              }

              // Apply animation to the main element
              applyAnimation($element, animationType);

              // Also apply animation to children that have animations
              const children = $element[0].children;
              for (let i = 0; i < children.length; i++) {
                const childStyle = window.getComputedStyle(children[i]);
                const childAnimation = childStyle.animation;

                if (
                  childAnimation.includes("fadeInUp") ||
                  childAnimation.includes("fadeInLeft") ||
                  childAnimation.includes("fadeIn")
                ) {
                  let childAnimType = "fadeIn";
                  if (childAnimation.includes("fadeInUp")) {
                    childAnimType = "fadeInUp";
                  } else if (childAnimation.includes("fadeInLeft")) {
                    childAnimType = "fadeInLeft";
                  }

                  applyAnimation($(children[i]), childAnimType);
                }
              }
            }, delay);
          });
        }
      });
    }, observerOptions);

    // Helper function to check if element has animation
    function hasAnimation(element, animationName) {
      const computedStyle = window.getComputedStyle(element);
      const animation = computedStyle.animation;
      return animation.includes(animationName);
    }

    // Helper function to check if element or its children have animation
    function hasAnimationOrChild(element, animationName) {
      // Check the element itself
      if (hasAnimation(element, animationName)) {
        return true;
      }

      // Check direct children (like img inside .xp-hero__bg)
      const children = element.children;
      for (let i = 0; i < children.length; i++) {
        if (hasAnimation(children[i], animationName)) {
          return true;
        }
      }

      return false;
    }

    // Find all elements with animations
    const $allElements = $("*");
    const animatedElements = [];

    $allElements.each(function () {
      const element = this;
      // Skip hero section elements to prevent conflicts
      if ($(element).closest(".xp-hero").length > 0) {
        return;
      }

      if (
        hasAnimationOrChild(element, "fadeInUp") ||
        hasAnimationOrChild(element, "fadeInLeft") ||
        hasAnimationOrChild(element, "fadeIn")
      ) {
        animatedElements.push(element);
      }
    });

    // Group elements by their parent section with improved detection
    const elementsBySection = new Map();

    animatedElements.forEach((element) => {
      const $element = $(element);
      const computedStyle = window.getComputedStyle(element);
      const animation = computedStyle.animation;

      // Determine animation type - check element first, then children
      let animationType = null;

      if (animation.includes("fadeInUp")) {
        animationType = "fadeInUp";
      } else if (animation.includes("fadeInLeft")) {
        animationType = "fadeInLeft";
      } else if (animation.includes("fadeIn")) {
        animationType = "fadeIn";
      } else {
        // Check children for animation
        const children = element.children;
        for (let i = 0; i < children.length; i++) {
          const childStyle = window.getComputedStyle(children[i]);
          const childAnimation = childStyle.animation;

          if (childAnimation.includes("fadeInUp")) {
            animationType = "fadeInUp";
            break;
          } else if (childAnimation.includes("fadeInLeft")) {
            animationType = "fadeInLeft";
            break;
          } else if (childAnimation.includes("fadeIn")) {
            animationType = "fadeIn";
            break;
          }
        }
      }

      if (animationType) {
        $element.data("animationType", animationType);
      }

      // Find the parent section with improved detection
      let $parentSection = $element.closest(
        'section, [class*="section"], [class*="content"], [class*="inner"], main, .xp-container, .xp-hero, .xp-split-content, .xp-product, .xp-highlighted-products, .xp-banner, .xp-video, .xp-assurance, .xp-faq, .xp-awards'
      );

      // If no section found, traverse up to find a meaningful container
      if ($parentSection.length === 0) {
        let $currentParent = $element.parent();
        while ($currentParent.length && $currentParent[0] !== document.body) {
          if (
            $currentParent[0].classList.length > 0 ||
            $currentParent[0].tagName === "SECTION"
          ) {
            $parentSection = $currentParent;
            break;
          }
          $currentParent = $currentParent.parent();
        }
        if ($parentSection.length === 0) {
          $parentSection = $element.parent();
        }
      }

      // Create unique section identifier
      const sectionId =
        $parentSection.attr("id") ||
        $parentSection.attr("class").split(" ")[0] ||
        $parentSection[0].tagName.toLowerCase() +
          "-" +
          Math.random().toString(36).substr(2, 9);

      if (!elementsBySection.has(sectionId)) {
        elementsBySection.set(sectionId, []);
      }
      elementsBySection.get(sectionId).push(element);
    });

    // Set up scroll animations with optimized section-based delays
    elementsBySection.forEach((sectionElements, sectionId) => {
      // Sort elements by their position in the DOM for consistent ordering
      sectionElements.sort((a, b) => {
        const position = a.compareDocumentPosition(b);
        return position & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });

      sectionElements.forEach((element, index) => {
        const $element = $(element);
        // Set delay: 1st child = 0ms, 2nd = 100ms, 3rd = 200ms, etc.
        $element.data("animationDelay", index * 100);

        // Disable initial CSS animation to prevent conflicts
        $element.css({
          animation: "none",
          opacity: "0",
        });

        observer.observe(element);
      });
    });

    // console.log(`Found ${animatedElements.length} animated elements`);
  }

  // Initialize scroll animations
  initScrollAnimations();

  // Global flag to track if hero has been animated on page load
  let heroAnimatedOnLoad = false;

  // Initialize hero section animations on page load
  function initHeroAnimations() {
    const $heroSection = $(".xp-hero");
    if ($heroSection.length === 0) return;

    // Always disable CSS animations for hero elements on page load
    $heroSection.find(".xp-hero__bg img").css("animation", "none");
    $heroSection.find(".xp-hero__subtitle").css("animation", "none");
    $heroSection.find(".xp-hero__title").css("animation", "none");
    $heroSection.find(".xp-primary-button").css("animation", "none");

    // Ensure hero background image starts with proper initial state
    const $heroBg = $heroSection.find(".xp-hero__bg img");
    if ($heroBg.length > 0) {
      $heroBg.css({
        opacity: "0",
        transform: "scale(0.9)",
        transition: "none",
      });
    }

    // Apply smooth JavaScript animations immediately
    setTimeout(() => {
      // Hero background image
      const $heroBg = $heroSection.find(".xp-hero__bg img");
      if ($heroBg.length > 0) {
        // Set initial state with !important to override CSS
        $heroBg[0].style.setProperty("opacity", "0", "important");
        $heroBg[0].style.setProperty("transform", "scale(0.9)", "important");
        $heroBg[0].style.setProperty("transition", "none", "important");

        // Force reflow
        $heroBg[0].offsetHeight;

        setTimeout(() => {
          // Apply animation with !important
          $heroBg[0].style.setProperty(
            "transition",
            "opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            "important"
          );
          $heroBg[0].style.setProperty("opacity", "1", "important");
          $heroBg[0].style.setProperty("transform", "scale(1)", "important");
        }, 100);
      }

      // Hero subtitle
      const $heroSubtitle = $heroSection.find(".xp-hero__subtitle");
      if ($heroSubtitle.length > 0) {
        $heroSubtitle.css({
          opacity: "0",
          transform: "translateX(50px)",
        });

        // Force reflow
        $heroSubtitle[0].offsetHeight;

        setTimeout(() => {
          $heroSubtitle.css({
            transition:
              "opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            opacity: "1",
            transform: "translateX(0)",
          });
        }, 300);
      }

      // Hero title
      const $heroTitle = $heroSection.find(".xp-hero__title");
      if ($heroTitle.length > 0) {
        $heroTitle.css({
          opacity: "0",
          transform: "translateX(50px)",
        });

        // Force reflow
        $heroTitle[0].offsetHeight;

        setTimeout(() => {
          $heroTitle.css({
            transition:
              "opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            opacity: "1",
            transform: "translateX(0)",
          });
        }, 500);
      }

      // Hero button
      const $heroButton = $heroSection.find(".xp-primary-button");
      if ($heroButton.length > 0) {
        $heroButton.css({
          opacity: "0",
          transform: "translateX(50px)",
        });

        // Force reflow
        $heroButton[0].offsetHeight;

        setTimeout(() => {
          $heroButton.css({
            transition:
              "opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            opacity: "1",
            transform: "translateX(0)",
          });
        }, 700);
      }

      // Clean up transitions after animation
      setTimeout(() => {
        if ($heroBg.length > 0) {
          $heroBg[0].style.removeProperty("transition");
          $heroBg[0].style.removeProperty("opacity");
          $heroBg[0].style.removeProperty("transform");
        }
        if ($heroSubtitle.length > 0) $heroSubtitle.css("transition", "");
        if ($heroTitle.length > 0) $heroTitle.css("transition", "");
        if ($heroButton.length > 0) $heroButton.css("transition", "");
      }, 2000);

      // Mark hero as animated on page load
      heroAnimatedOnLoad = true;
    }, 200);
  }

  // Initialize hero animations
  // initHeroAnimations(); // Commented out for testing

  // Initialize hero scroll animations (for when scrolling to hero from other sections)
  function initHeroScrollAnimations() {
    const $heroSection = $(".xp-hero");
    if ($heroSection.length === 0) return;

    // Create intersection observer for hero section
    const heroObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const $heroSection = $(entry.target);

            // Get hero elements
            const $heroBg = $heroSection.find(".xp-hero__bg img");
            const $heroSubtitle = $heroSection.find(".xp-hero__subtitle");
            const $heroTitle = $heroSection.find(".xp-hero__title");
            const $heroButton = $heroSection.find(".xp-primary-button");

            // Only animate if elements are not already visible (opacity: 0)
            if ($heroBg.length > 0 && $heroBg.css("opacity") === "0") {
              // Hero background image
              $heroBg[0].style.setProperty("opacity", "0", "important");
              $heroBg[0].style.setProperty(
                "transform",
                "scale(0.9)",
                "important"
              );
              $heroBg[0].style.setProperty("transition", "none", "important");

              setTimeout(() => {
                $heroBg[0].style.setProperty(
                  "transition",
                  "opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  "important"
                );
                $heroBg[0].style.setProperty("opacity", "1", "important");
                $heroBg[0].style.setProperty(
                  "transform",
                  "scale(1)",
                  "important"
                );
              }, 100);
            }

            if (
              $heroSubtitle.length > 0 &&
              $heroSubtitle.css("opacity") === "0"
            ) {
              // Hero subtitle
              $heroSubtitle.css({
                opacity: "0",
                transform: "translateX(50px)",
                transition: "none",
              });

              setTimeout(() => {
                $heroSubtitle.css({
                  transition:
                    "opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  opacity: "1",
                  transform: "translateX(0)",
                });
              }, 300);
            }

            if ($heroTitle.length > 0 && $heroTitle.css("opacity") === "0") {
              // Hero title
              $heroTitle.css({
                opacity: "0",
                transform: "translateX(50px)",
                transition: "none",
              });

              setTimeout(() => {
                $heroTitle.css({
                  transition:
                    "opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  opacity: "1",
                  transform: "translateX(0)",
                });
              }, 500);
            }

            if ($heroButton.length > 0 && $heroButton.css("opacity") === "0") {
              // Hero button
              $heroButton.css({
                opacity: "0",
                transform: "translateX(50px)",
                transition: "none",
              });

              setTimeout(() => {
                $heroButton.css({
                  transition:
                    "opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  opacity: "1",
                  transform: "translateX(0)",
                });
              }, 700);
            }
          }
        });
      },
      {
        threshold: 0.3, // Trigger when 30% of hero section is visible
        rootMargin: "0px",
      }
    );

    // Observe the hero section
    heroObserver.observe($heroSection[0]);
  }

  // Initialize hero scroll animations
  initHeroScrollAnimations();

  // Stats Counter Animation
  function initStatsCounter() {
    const $statsSection = $(".xp-stats");
    const $statNumbers = $(".xp-stat__number");

    if ($statsSection.length === 0 || $statNumbers.length === 0) return;

    // Store original values
    const originalValues = [];
    $statNumbers.each(function () {
      const text = $(this).text().trim();
      // Extract numeric value from text (handles "4K", "100+", "4.9" etc.)
      let numericValue = 0;
      if (text.includes("K")) {
        numericValue = parseFloat(text.replace("K", "")) * 1000;
      } else if (text.includes("+")) {
        numericValue = parseFloat(text.replace("+", ""));
      } else {
        numericValue = parseFloat(text);
      }
      originalValues.push({ text, numericValue });
    });

    // Create intersection observer for stats section
    const statsObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const $target = $(entry.target);
          if (entry.isIntersecting && !$target.hasClass("stats-animated")) {
            $target.addClass("stats-animated");

            // Animate each stat number
            $statNumbers.each(function (index) {
              const { text, numericValue } = originalValues[index];
              animateCounter($(this), numericValue, text, 2000); // 2 second animation
            });

            // Stop observing once animated
            statsObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of section is visible
        rootMargin: "0px 0px 200px 0px", // Start 200px before section enters viewport
      }
    );

    // Start observing the stats section
    statsObserver.observe($statsSection[0]);
  }

  // Counter animation function
  function animateCounter($element, targetValue, originalText, duration) {
    const startTime = performance.now();
    const startValue = 0;

    // Determine if we need to format the number (K, +, decimal)
    const needsFormatting =
      originalText.includes("K") ||
      originalText.includes("+") ||
      originalText.includes(".");

    function updateCounter(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Use easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentValue =
        startValue + (targetValue - startValue) * easeOutQuart;

      // Format the number based on original text
      let displayValue;
      if (originalText.includes("K")) {
        displayValue = Math.round(currentValue / 1000) + "K";
      } else if (originalText.includes("+")) {
        displayValue = Math.round(currentValue) + "+";
      } else if (originalText.includes(".")) {
        displayValue = currentValue.toFixed(1);
      } else {
        displayValue = Math.round(currentValue);
      }

      $element.text(displayValue);

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      } else {
        // Ensure final value is exactly the original
        $element.text(originalText);
      }
    }

    requestAnimationFrame(updateCounter);
  }

  // Initialize stats counter
  initStatsCounter();

  // FAQ Accordion
  $(".xp-faq__question").on("click", function () {
    const $this = $(this);
    const $item = $this.closest(".xp-faq__item");
    const $icon = $this.find(".xp-faq__icon");
    const $answer = $item.find(".xp-faq__answer");
    const isActive = $item.hasClass("xp-faq__item--active");

    // Close all FAQ items
    $(".xp-faq__item").removeClass("xp-faq__item--active");
    $(".xp-faq__icon").text("+");
    $(".xp-faq__answer").css("max-height", "0px");

    // If the clicked item wasn't active, open it
    if (!isActive) {
      $item.addClass("xp-faq__item--active");
      $icon.text("-");

      // Get the natural height of the content
      const answerHeight = $answer[0].scrollHeight;

      // Set the calculated height with small buffer to prevent text cutoff
      $answer.css("max-height", answerHeight + 10 + "px");
    }
  });

  // Product Features Tab Active on Scroll
  const $scrollContainer = $(".xp-product-features__scroll-container");
  const $fixedSection = $(".xp-product-features__fixed-section");
  const $tabItems = $(".xp-product-features__tab");
  const $productImages = $(".xp-product-features__image");
  const totalTabs = $tabItems.length;

  // Insert tab images dynamically
  function insertTabImages() {
    if ($(window).width() <= 976) {
      $tabItems.each(function (index) {
        const $tab = $(this);
        const tabIndex = $tab.data("tab");
        const tabImgSrc = $tab.data("src");
        // Check if image already exists
        if (!$tab.find(".xp-product-features__tab-image").length) {
          const imageSrc = tabImgSrc;
          const $image = $(
            `<img src="${imageSrc}" alt="Product" class="xp-product-features__tab-image" data-tab="${tabIndex}" loading="lazy" />`
          );
          $tab.append($image);
        }
      });
    }
  }

  // Accordion functionality for mobile and tablet
  function initAccordion() {
    if ($(window).width() <= 976) {
      // Insert images first
      insertTabImages();

      $tabItems.off("click.accordion").on("click.accordion", function () {
        const $clickedTab = $(this);
        const isActive = $clickedTab.hasClass(
          "xp-product-features__tab--active"
        );

        // Close all tabs
        $tabItems.removeClass("xp-product-features__tab--active");

        // If the clicked tab wasn't active, open it
        if (!isActive) {
          $clickedTab.addClass("xp-product-features__tab--active");
        }
      });
    } else {
      // Remove accordion click handlers on desktop
      $tabItems.off("click.accordion");
      // Remove tab images on desktop
      $(".xp-product-features__tab-image").remove();
    }
  }

  function updateProductFeaturesTabs() {
    // Only run scroll-based updates on desktop
    if ($(window).width() <= 976) {
      return;
    }
    if($scrollContainer.length == 0) return;
    const scrollTop = $(window).scrollTop();
    const windowHeight = window.innerHeight;;
    const containerOffset = $scrollContainer.offset().top;
    const containerHeight = $scrollContainer.height();

    // Calculate scroll range for the entire section
    const scrollStart = containerOffset;
    const scrollEnd = containerOffset + containerHeight - windowHeight;

    // Check if we're within the scroll container
    if (scrollTop < scrollStart) {
      // Before section - show first tab
      $tabItems.removeClass("xp-product-features__tab--active");
      $tabItems.eq(0).addClass("xp-product-features__tab--active");
      $productImages.removeClass("xp-product-features__image--active");
      const $firstImage = $productImages.eq(0);
      $firstImage.addClass("xp-product-features__image--active");

      // Ensure the first image is loaded (for lazy loading)
      if ($firstImage.length && $firstImage.hasClass("loaded")) {
        // Image is already loaded, nothing to do
      } else if ($firstImage.length) {
        // Force load the image if it's lazy loaded
        const img = $firstImage[0];
        if (img && img.src) {
          const tempImg = new Image();
          tempImg.onload = function () {
            $firstImage.addClass("loaded");
          };
          tempImg.src = img.src;
        }
      }

      $(".xp-product-features__tab-progress-fill").css("height", "0%");
    } else if (scrollTop >= scrollStart && scrollTop <= scrollEnd) {
      // Within section - animate through tabs
      const relativeScroll = scrollTop - scrollStart;
      const totalScrollRange = scrollEnd - scrollStart;
      const tabScrollRange = totalScrollRange / totalTabs;

      // Calculate current tab index
      const currentTabIndex = Math.min(
        Math.floor(relativeScroll / tabScrollRange),
        totalTabs - 1
      );

      // Calculate progress within current tab
      const tabProgress = (relativeScroll % tabScrollRange) / tabScrollRange;

      // Update active tab
      $tabItems.removeClass("xp-product-features__tab--active");
      $tabItems
        .eq(currentTabIndex)
        .addClass("xp-product-features__tab--active");

      // Update active image with fade transition
      $productImages.removeClass("xp-product-features__image--active");
      const $activeImage = $productImages.filter(
        `[data-tab="${currentTabIndex}"]`
      );
      $activeImage.addClass("xp-product-features__image--active");

      // Ensure the active image is loaded (for lazy loading)
      if ($activeImage.length && $activeImage.hasClass("loaded")) {
        // Image is already loaded, nothing to do
      } else if ($activeImage.length) {
        // Force load the image if it's lazy loaded
        const img = $activeImage[0];
        if (img && img.src) {
          const tempImg = new Image();
          tempImg.onload = function () {
            $activeImage.addClass("loaded");
          };
          tempImg.src = img.src;
        }
      }

      // Update progress bars for all tabs
      $tabItems.each(function (index) {
        const $progressFill = $(this).find(
          ".xp-product-features__tab-progress-fill"
        );

        if (index < currentTabIndex) {
          // Completed tabs
          $progressFill.css("height", "100%");
        } else if (index === currentTabIndex) {
          // Current tab
          $progressFill.css("height", tabProgress * 100 + "%");
        } else {
          // Upcoming tabs
          $progressFill.css("height", "0%");
        }
      });
    } else {
      // After section - show last tab
      $tabItems.removeClass("xp-product-features__tab--active");
      $tabItems.eq(totalTabs - 1).addClass("xp-product-features__tab--active");
      $productImages.removeClass("xp-product-features__image--active");
      const $lastImage = $productImages.eq(totalTabs - 1);
      $lastImage.addClass("xp-product-features__image--active");

      // Ensure the last image is loaded (for lazy loading)
      if ($lastImage.length && $lastImage.hasClass("loaded")) {
        // Image is already loaded, nothing to do
      } else if ($lastImage.length) {
        // Force load the image if it's lazy loaded
        const img = $lastImage[0];
        if (img && img.src) {
          const tempImg = new Image();
          tempImg.onload = function () {
            $lastImage.addClass("loaded");
          };
          tempImg.src = img.src;
        }
      }

      // All progress bars filled
      $(".xp-product-features__tab-progress-fill").css("height", "100%");
    }
  }

  // Throttle scroll event for better performance
  let ticking = false;
  $(window).on("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateProductFeaturesTabs();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Handle window resize
  $(window).on("resize", function () {
    initAccordion();
    // Reset to first tab active on mobile and tablet
    // if ($(window).width() <= 976) {
    //   $tabItems.removeClass("xp-product-features__tab--active");
    //   $tabItems.eq(0).addClass("xp-product-features__tab--active");
    // }
  });

  // Initial calls
  initAccordion();
  updateProductFeaturesTabs();

  // Ensure first tab is active on mobile/tablet on page load
  if ($(window).width() <= 976) {
    $tabItems.removeClass("xp-product-features__tab--active");
    $tabItems.eq(0).addClass("xp-product-features__tab--active");
  }

  // Variation tab
  const $variantTabs = $(".xp-variant-tab");
  const $watchImages = $(".xp-watch-image");
  const $buyButton = $("#buyButton");

  function updateWatchDisplay(activeIndex) {
    // Remove all classes from watch images
    $watchImages.removeClass("active next next2");

    // Check screen size
    const isSmallScreen = $(window).width() < 560;

    // Add classes based on position relative to active image with circular logic
    $watchImages.each(function (index) {
      const $img = $(this);
      if (index === activeIndex) {
        $img.addClass("active");
      } else if (index === (activeIndex + 1) % $watchImages.length) {
        $img.addClass("next");
      } else if (
        !isSmallScreen &&
        index === (activeIndex + 2) % $watchImages.length
      ) {
        // Only show next2 on larger screens
        $img.addClass("next2");
      }
    });
  }

  function updateBuyButtonLink($activeTab) {
    const link = $activeTab.data("link");
    if ($buyButton.length && link) {
      $buyButton.attr("href", link);
    }
  }

  function switchVariant(targetVariant) {
    // Update tab states
    let $activeTab = null;
    $variantTabs.each(function () {
      const $tab = $(this);
      $tab.removeClass("active");
      if ($tab.data("variant") === targetVariant) {
        $tab.addClass("active");
        $activeTab = $tab;
      }
    });

    // Find active image index
    let activeIndex = 0;
    $watchImages.each(function (index) {
      const $img = $(this);
      if ($img.data("variant") === targetVariant) {
        activeIndex = index;
      }
    });

    // Update watch display
    updateWatchDisplay(activeIndex);

    // Update buy button link
    if ($activeTab) {
      updateBuyButtonLink($activeTab);
    }
  }

  
  // Add click event listeners to variant tabs
  $variantTabs.on("click", function () {
    
    const variant = $(this).data("variant");
    console.log(variant);
    switchVariant(variant);
  });

  // Initialize with first variant active
  updateWatchDisplay(0);
  if ($variantTabs.length) {
    updateBuyButtonLink($variantTabs.first());
  }

  // Navigation arrows functionality
  const $prevArrow = $("#prevVariant");
  const $nextArrow = $("#nextVariant");

  function getActiveVariantIndex() {
    let activeIndex = 0;
    $variantTabs.each(function (index) {
      if ($(this).hasClass("active")) {
        activeIndex = index;
      }
    });
    return activeIndex;
  }

  function getAllVariants() {
    const variants = [];
    $variantTabs.each(function () {
      variants.push($(this).data("variant"));
    });
    return variants;
  }

  // Previous arrow click
  $prevArrow.on("click", function () {
    const currentIndex = getActiveVariantIndex();
    const variants = getAllVariants();
    const prevIndex = (currentIndex - 1 + variants.length) % variants.length;
    const prevVariant = variants[prevIndex];
    switchVariant(prevVariant);
  });

  // Next arrow click
  $nextArrow.on("click", function () {
    const currentIndex = getActiveVariantIndex();
    const variants = getAllVariants();
    const nextIndex = (currentIndex + 1) % variants.length;
    const nextVariant = variants[nextIndex];
    switchVariant(nextVariant);
  });

  // Update display on window resize to handle responsive behavior
  $(window).on("resize", function () {
    // Get current active variant
    const $activeTab = $variantTabs.filter(".active");
    if ($activeTab.length) {
      const activeVariant = $activeTab.data("variant");
      // Find active image index
      let activeIndex = 0;
      $watchImages.each(function (index) {
        const $img = $(this);
        if ($img.data("variant") === activeVariant) {
          activeIndex = index;
        }
      });
      // Update display with new screen size
      updateWatchDisplay(activeIndex);
    }
  });
  // Mobile-only Insta Reels slider (< 760px)
  (function initReelsSliderMobileOnly() {
    const reelsSelector = ".xp-reels-slider";
    let reelsSwiper = null;

    function mountReels() {
      if (reelsSwiper) return;
      const $container = $(reelsSelector);
      if (!$container.length) return;

      // Ensure Swiper DOM structure on mobile
      if (!$container.hasClass("swiper")) {
        $container.addClass("swiper");
      }

      // Move existing items into a swiper-wrapper and mark as slides
      let $wrapper = $container.children(".swiper-wrapper");
      if (!$wrapper.length) {
        $wrapper = $('<div class="swiper-wrapper"></div>');
        const $items = $container.children(".xp-insta__item");
        $items.addClass("swiper-slide").appendTo($wrapper);
        $container.append($wrapper);
      } else {
        // If wrapper exists, make sure slides have proper class
        $wrapper.children().addClass("swiper-slide");
      }

      reelsSwiper = initSlider(reelsSelector, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        grabCursor: true,
      });
    }

    function unmountReels() {
      const $container = $(reelsSelector);
      if (!reelsSwiper && !$container.length) return;

      if (reelsSwiper) {
        reelsSwiper.destroy(true, true);
        reelsSwiper = null;
      }

      // Revert DOM back to original (no swiper classes/structure)
      if ($container.length) {
        const $wrapper = $container.children(".swiper-wrapper");
        if ($wrapper.length) {
          const $slides = $wrapper.children(".swiper-slide");
          $slides.removeClass("swiper-slide").appendTo($container);
          $wrapper.remove();
        }
        $container.removeClass("swiper");
      }
    }

    function handleMq(e) {
      if (e.matches) {
        mountReels();
      } else {
        unmountReels();
      }
    }

    const mq = window.matchMedia("(max-width: 767px)");
    // Initialize on load
    handleMq(mq);
    // Listen for changes
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", handleMq);
    } else if (typeof mq.addListener === "function") {
      // Fallback for older browsers
      mq.addListener(handleMq);
    }
  })();
});
